/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
// import { AdminBookInfomation } from './book-Infomation';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as toast from '../../../_store/slice/toast';
import server from '../../../_api/backend';

import { RelatedBooks } from './relatedBooks';

const flagEdition = [
  { id: '0', text: '초판' },
  { id: '1', text: '재판' },
];

export function AdminNewBook(routeProps: RouteComponentProps) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [categories, setCategories] = useState<any>([]);
  const [subCategory, setSubCategory] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>();
  const [selectedSubCategory, setSelectedSubCategory] = useState<number>(0);
  const [bookName, setBookName] = useState<string>('');
  const [bookPrice, setBookPrice] = useState<number>(0); // 판매가
  const [bookPriceFull, setBookPriceFull] = useState<number>(0); // 정상가
  const [bookPriceMember, setBookPriceMember] = useState<number>(0);
  const [bookPriceNonmember, setBookPriceNonmember] = useState<number>(0);
  const [bookPoint, setBookPoint] = useState<number>(0);
  const [bookFlagType, setBookFlagType] = useState<string>('0');
  const [selectedEdition, setSelectedEdition] = useState<string>('');
  const [sizeType, setSizeType] = useState<string>('');
  const [isColorBook, setIsColorBook] = useState<string>('N');
  const [hasCD, setHasCD] = useState<string>('N');
  const [hasVideos, setHasVideos] = useState<string>('N');
  const [bookCollege, setBookCollege] = useState<string>('');
  const [publicationDate, setPublicationDate] = useState<string>('');
  const [bookQty, setBookQty] = useState<number>(0);
  const [bookPageCount, setBookPageCount] = useState<number>(0);
  const [publisher, setPublisher] = useState<string>('');
  const [urlMovies, setUrlMovies] = useState<string>('');
  const [urlYoutubes, setUrlYoutubes] = useState<string>('');
  const [urlBlogs, setUrlBlogs] = useState<string>('');
  const [bookisbn, setBookIsbn] = useState<string>('');
  const [bookIntroduce, setBookIntroduce] = useState<string>('');
  const [bookContents, setBookContents] = useState<string>('');
  const [bookAuthor, setBookAuthor] = useState<string>('');
  const [bookAuthorIntroduce, setBookAuthorIntroduce] = useState<string>('');
  const [isMainBook, setIsMainBook] = useState<string>('N');
  const [isBestBook, setIsBestBook] = useState<string>('N');
  const [isNewBooks, setIsNewBooks] = useState<string>('N');
  const [isRecommendBook, setIsRecommendBook] = useState<string>('N');
  const [isDisplayBook, setIsDisplayBook] = useState<string>('Y');

  // 업로드 예정 파일 ( 추가하는 이미지 파일 )
  const [attachingSmallImg, setAttachingSmallImg] = useState<File>();
  const [attachingMiddleImg, setAttachingMiddleImg] = useState<any>();
  const [attachingMainImg, setAttachingMainImg] = useState<File>();
  const [attachingDetailImg, setAttachingDetailImg] = useState<any>();

  const [attachingMiddleImgView, setAttachingMiddleImgView] = useState<any>(null);
  const [attachingDetailImgView, setAttachingDetailImgView] = useState<any>(null);

  const [isShowRelated, setIsShowRelated] = useState<boolean>(false);

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getCategoryList();
    // getBookDetail();
  }, []);

  const getCategoryList = async () => {
    await server
      .getCategories()
      .then((payload) => {
        setCategories(payload);
      })
      .catch((error) => {
        console.log('카테고리 에러 ', error);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // const isbnRule = /^(?:ISBN(?:-13)?:? )?(?=[0-9]{13}$|(?=(?:[0-9]+[- ]){4})[- 0-9]{17}$)97[89][- ]?[0-9]{1,5}[- ]?[0-9]+[- ]?[0-9]+[- ]?[0-9]$/;

  // const dateRule = /^\d{4}[/-]\d{2}[/-]\d{2}$/; // 발간일 정규 표현식

  const isbnRule = /^\d{3}[/-]\d{2}[/-]\d{4}[/-]\d{3}[/-]\d{1}$/; // isbn 정규 표현식 ( 111-11-1111-111-1 )

  const isbnRule2 = /^\d{3}[/-]\d{2}[/-]\d{4}[/-]\d{3}[/-]\d{1}\s?\d{2,3}$/; // isbn 정규 표현식 ( 111-11-1111-111-1 23) - 띄어쓰기 포함

  const onClickValidation = () => {
    if (!categories) {
      dispatch(toast.error({ message: '카테고리를 선택해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (!subCategory) {
      dispatch(
        toast.error({ message: '서브 카테고리를 선택해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (selectedSubCategory === 0) {
      dispatch(toast.error({ message: '카테고리를 선택해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (!bookName) {
      dispatch(toast.error({ message: '도서명을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookPriceFull <= 0) {
      dispatch(toast.error({ message: '정가를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookPrice <= 0) {
      dispatch(toast.error({ message: '판매가를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookPriceNonmember <= 0) {
      dispatch(
        toast.error({ message: '비회원가격을 입력해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (bookFlagType.length <= 0) {
      dispatch(toast.error({ message: '구분을 선택해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (selectedEdition.length <= 0) {
      dispatch(
        toast.error({ message: '출간구분 값을 선택해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (publicationDate.length <= 0) {
      dispatch(toast.error({ message: '발간일을 확인해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    // if (!dateRule.test(publicationDate)) {
    //   dispatch(
    //     toast.error({
    //       message: '발간일을 확인해주세요.',
    //       title: '필수 입력 항목 누락 또는 발간일 형식이 맞지 않습니다.',
    //     })
    //   );
    //   return;
    // }
    if (bookPageCount <= 0) {
      dispatch(toast.error({ message: '페이지수를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (publisher.length <= 0) {
      dispatch(toast.error({ message: '출판사를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (attachingMiddleImg === null) {
      dispatch(
        toast.error({ message: '도서 이미지를 업로드해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (bookisbn.length <= 0) {
      dispatch(toast.error({ message: '도서 ISBN을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    onClickSaveBookData();
    // if (isbnRule.test(bookisbn) || isbnRule2.test(bookisbn)) {
    //   onClickSaveBookData();
    // } else {
    //   dispatch(
    //     toast.error({
    //       message: 'ISBN을 확인해주세요.',
    //       title: '필수 입력 항목 누락 또는 ISBN 형식이 맞지 않습니다.',
    //     })
    //   );
    // }
  };

  const onClickSaveBookData = async () => {
    if (window.confirm('저장하시겠습니까?')) {
      const savedBook = await server
        .createBooks({
          category: +selectedSubCategory,
          name: bookName,
          size: sizeType,
          isbn: bookisbn,
          pageCount: bookPageCount,
          college: bookCollege,
          author: bookAuthor,
          authorIntroduce: bookAuthorIntroduce,
          introduce: bookIntroduce,
          contents: bookContents,
          qty: bookQty,
          point: bookPoint,
          price: bookPrice,
          priceFull: bookPriceFull,
          priceMember: bookPriceMember,
          priceNonmember: bookPriceNonmember,
          flagType: bookFlagType,
          flagEdition: selectedEdition,
          isMain: isMainBook,
          isBest: isBestBook,
          isNew: isNewBooks,
          isRecommendation: isRecommendBook,
          isDisplay: isDisplayBook,
          isColor: isColorBook,
          hasCd: hasCD,
          hasVideo: hasVideos,
          urlYoutube: urlYoutubes,
          urlBlog: urlBlogs,
          urlMovie: urlMovies,
          publicationDate,
          publisher,
        })
        .then((payload) => {
          routeProps.history.push('/admin/book/list/all');
          return payload;
        })
        .catch((error) => {
          console.log('도서 저장에러 : ', error);
        });

      if (savedBook !== undefined) {
        const bookid = savedBook.id;
        if (
          attachingSmallImg !== undefined ||
          attachingMiddleImg !== undefined ||
          attachingMainImg !== undefined ||
          attachingDetailImg !== undefined
        ) {
          await server
            .fileUploadBooks(bookid, {
              imageSmall: attachingSmallImg,
              imageMiddle: attachingMiddleImg,
              imageMain: attachingMainImg,
              imageDetail: attachingDetailImg,
            })
            .then(() => {
              routeProps.history.push('/admin/book/list/all');
            })
            .catch((error) => {
              dispatch(toast.error({ message: '첨부파일 에러.' }));
              return error;
            });
        }
      }
    }
  };

  // 도서 이미지 미리보기 (도서 중간이미지)
  function attachingMiddleImgBlob(event: any) {
    const imageFile = event;
    if (imageFile === undefined) {
      const imageUrl = URL.createObjectURL(attachingMiddleImg);
      setAttachingMiddleImgView(imageUrl);
    } else {
      const imageUrl = URL.createObjectURL(imageFile);
      setAttachingMiddleImg(imageFile);
      setAttachingMiddleImgView(imageUrl);
    }
  }

  // 도서 이미지 미리보기 (도서 상세이미지)
  function attachingDetailImgBlob(event: any) {
    const imageFile = event;
    if (imageFile === undefined) {
      const imageUrl = URL.createObjectURL(attachingDetailImg);
      setAttachingDetailImgView(imageUrl);
    } else {
      const imageUrl = URL.createObjectURL(imageFile);
      setAttachingDetailImg(imageFile);
      setAttachingDetailImgView(imageUrl);
    }
  }

  return (
    <main className="new wrapper">
      <div className="title">
        <h1>신규 도서 등록</h1>
        <div className="buttons">
          <button type="button" onClick={() => onClickValidation()}>
            저장
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li className="book-categories">
            <span className="required">카테고리</span>
            <div>
              <div className="selectbox">
                <select
                  name="categoryBox"
                  id="categoryBox"
                  onChange={(option: any) => {
                    const val = option.target.value;
                    setSelectedCategory(val);
                    const child = categories.find((category: any) => category.id === val);
                    if (child && child.children) {
                      setSubCategory(child.children);
                    }
                  }}
                >
                  {categories &&
                    categories.map((parent: any) => (
                      <option value={parent.id} key={parent.id}>
                        {parent.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="selectbox">
                <select
                  name="subCategoryBox"
                  id="subCategoryBox"
                  onChange={(option: any) => {
                    const val = option.target.value;
                    setSelectedSubCategory(val);
                  }}
                >
                  {subCategory.map((category: any) => (
                    <option value={category.id} key={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <small>※ 하단의 카테고리 코드가 0일 시, 카테고리를 다시 한번 선택해주세요.</small>
          </li>
          <li className="col-3 book-codes">
            <div className="col">
              <span>카테고리 코드</span>
              <input readOnly type="number" value={selectedSubCategory} />
            </div>
            {/* <div className="col">
              <span>도서 코드</span>
              <input readOnly type="number" defaultValue={bookItem?.code ? bookItem?.code : ''} />
            </div> */}
          </li>
          <li className="book-title required">
            <span className="required">도서명</span>
            <input
              className="full"
              type="text"
              defaultValue={bookName || ''}
              onChange={(e: any) => {
                setBookName(e.target.value);
              }}
            />
          </li>
          <li className="price required">
            <span className="required">정가</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPriceFull(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="price required">
            <span className="required">판매가</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPrice(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="price required">
            <span>회원가격</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPriceMember(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="price required">
            <span className="required">비회원가격</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPriceNonmember(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="mileage">
            <span>구매포인트</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPoint(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="input required">
            <span className="required">구분</span>
            <div className="selectbox">
              <select
                name="flagTypeBox"
                id="flagTypeBox"
                onChange={(e: any) => {
                  setBookFlagType(e.target.value);
                }}
                defaultValue="0"
              >
                <option value="0">단행본</option>
                <option value="1">전공서적</option>
                <option value="2">수험서</option>
                <option value="3">기타</option>
              </select>
            </div>
          </li>
          <li className="input required">
            <span className="required">출간구분</span>
            {flagEdition.map((item: any) => (
              <div key={item.id}>
                <input
                  id={item.id}
                  type="radio"
                  name="publish"
                  checked={selectedEdition === item.id}
                  onChange={() => setSelectedEdition(item.id)}
                />
                <label htmlFor={item.id}>{item.text}</label>
              </div>
            ))}
          </li>
          <li className="input">
            <span>판형</span>
            <input
              type="text"
              onChange={(e) => {
                setSizeType(e.target.value);
              }}
            />
          </li>
          <li className="input">
            <span>컬러</span>
            <input
              id="noColor"
              type="radio"
              name="color"
              onChange={() => setIsColorBook('N')}
              checked={isColorBook === 'N'}
            />
            <label htmlFor="noColor">없음</label>
            <input
              id="yesColor"
              type="radio"
              name="color"
              onChange={() => setIsColorBook('Y')}
              checked={isColorBook === 'Y'}
            />
            <label htmlFor="yesColor">있음</label>
          </li>
          <li className="input">
            <span>CD</span>
            <input
              id="noCD"
              type="radio"
              name="CD"
              onChange={() => setHasCD('N')}
              checked={hasCD === 'N'}
            />
            <label htmlFor="noCD">없음</label>
            <input
              id="yesCD"
              type="radio"
              name="CD"
              onChange={() => setHasCD('Y')}
              checked={hasCD === 'Y'}
            />
            <label htmlFor="yesCD">있음</label>
          </li>
          <li className="input">
            <span>동영상</span>
            <input
              id="noVideo"
              type="radio"
              name="video"
              onChange={() => setHasVideos('N')}
              checked={hasVideos === 'N'}
            />
            <label htmlFor="noVideo">없음</label>
            <input
              id="yesVideo"
              type="radio"
              name="video"
              onChange={() => setHasVideos('Y')}
              checked={hasVideos === 'Y'}
            />
            <label htmlFor="yesVideo">있음</label>
          </li>
          <li>
            <span>대학명</span>
            <input
              type="text"
              onChange={(e: any) => {
                setBookCollege(e.target.value);
              }}
            />
            <small>※ 대학교재일 때에는 대학배너의 대학명과 반드시 동일하게 적어주세요.</small>
          </li>
          <li className="required">
            <span className="required">발간일</span>
            <input
              type="text"
              onChange={(e: any) => {
                setPublicationDate(e.target.value);
              }}
            />
            <small>※ 입력 형식: 2021-06-25</small>
          </li>
          <li>
            <span>수량</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookQty(Number(e.target.value));
              }}
            />
            <small>※ 품절일 경우 &quot;0&quot;으로 입력해주세요.</small>
          </li>
          <li className="input required">
            <span className="required">페이지수</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPageCount(Number(e.target.value));
              }}
            />
          </li>
          <li className="input required">
            <span className="required">출판사</span>
            <input
              type="text"
              onChange={(e: any) => {
                setPublisher(e.target.value);
              }}
            />
          </li>
          <li>
            <span>Youtube</span>
            <input
              type="url"
              onChange={(e: any) => {
                setUrlYoutubes(e.target.value);
              }}
            />
          </li>
          <li>
            <span>Blog</span>
            <input
              type="url"
              onChange={(e: any) => {
                setUrlBlogs(e.target.value);
              }}
            />
          </li>
          <li>
            <span className="required">ISBN</span>
            <input
              type="text"
              onChange={(e: any) => {
                setBookIsbn(e.target.value);
              }}
            />
            {/* <small>※ 형식: 978-89-7074-619-3 또는 978-89-7074-897-9 93 형식으로 맞춰주세요.</small> */}
          </li>
          <li>
            <span>도서소개 및 특징</span>
            <textarea
              rows={10}
              onChange={(e: any) => {
                setBookIntroduce(e.target.value);
              }}
            />
          </li>
          <li>
            <span>목차</span>
            <textarea
              rows={10}
              onChange={(e: any) => {
                setBookContents(e.target.value);
              }}
            />
          </li>
          <li className="required">
            <span className="required">저자이름</span>
            <input
              type="text"
              onChange={(e: any) => {
                setBookAuthor(e.target.value);
              }}
            />
          </li>
          <li>
            <span>저자소개</span>
            <textarea
              rows={10}
              onChange={(e: any) => {
                setBookAuthorIntroduce(e.target.value);
              }}
            />
          </li>
          <li>
            <span className="required">도서 이미지 (247x315)</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                onChange={(e) => {
                  if (e.target !== null && e.target.files !== null) {
                    attachingMiddleImgBlob(e.target.files[0]);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <small className="file-return">
              {attachingMiddleImg && <img src={attachingMiddleImgView} alt="" />}
            </small>
          </li>
          <li>
            <span>상세내용 이미지 (가로사이즈: 610px)</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file04"
                type="file"
                onChange={(e) => {
                  if (e.target !== null && e.target.files !== null) {
                    attachingDetailImgBlob(e.target.files[0]);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file04" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <small className="file-return">
              {attachingDetailImg && <img src={attachingDetailImgView} alt="" />}
            </small>
          </li>
          <li>
            <span>도서 유형구분</span>
            <div className="checkboxes">
              <div className="checkbox">
                <input
                  id="bookType01"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsMainBook(e.target.checked);
                    if (isMainBook === 'N') {
                      setIsMainBook('Y');
                    } else {
                      setIsMainBook('N');
                    }
                  }}
                />
                <label htmlFor="bookType01">메인도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType02"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsBestBook(e.target.value);
                    if (isBestBook === 'N') {
                      setIsBestBook('Y');
                    } else {
                      setIsBestBook('N');
                    }
                  }}
                />
                <label htmlFor="bookType02">BEST도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType03"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsNewBooks(e.target.checked);
                    if (isNewBooks === 'N') {
                      setIsNewBooks('Y');
                    } else {
                      setIsNewBooks('N');
                    }
                  }}
                  value={isNewBooks}
                />
                <label htmlFor="bookType03">신간도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType04"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsRecommendBook(e.target.checked);
                    if (isRecommendBook === 'N') {
                      setIsRecommendBook('Y');
                    } else {
                      setIsRecommendBook('N');
                    }
                  }}
                />
                <label htmlFor="bookType04">추천도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType05"
                  type="checkbox"
                  defaultChecked
                  onChange={(e: any) => {
                    setIsDisplayBook(e.target.checked);
                    if (isDisplayBook === 'N') {
                      setIsDisplayBook('Y');
                    } else {
                      setIsDisplayBook('N');
                    }
                  }}
                />
                <label htmlFor="bookType05">전시도서</label>
              </div>
            </div>
          </li>
          {/* <li className="choose-books">
            <span>관련도서</span>
            <div>
              <button
                onClick={() => {
                  setIsShowRelated(true);
                }}
              >
                관련도서등록
              </button>
              <RelatedBooks />
            </div>
          </li> */}
        </ul>
      </div>
      {/* {AdminBookInfomation(false, '1153')} */}
    </main>
  );
}
